import { OutlinedInput } from '@mui/material';
import { forwardRef } from 'react';
import type { FocusEvent } from 'react';

import type { FieldBaseProps } from './field.types';
import { FieldShell, describedBy } from './FieldShell';
import { controlTextSx } from './fieldStyles';
import { useFieldIds } from './useFieldIds';

export interface TimeInputProps extends FieldBaseProps {
  value: string;
  onValueChange: (value: string) => void;
  min?: string;
  max?: string;
  readOnly?: boolean;
  name?: string;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
}

export const TimeInput = forwardRef<HTMLDivElement, TimeInputProps>(function TimeInput(
  {
    id: idProp,
    label,
    hideLabel,
    helperText,
    describedById,
    error,
    required,
    hideRequiredMark,
    disabled,
    size = 'small',
    fullWidth = true,
    className,
    sx,
    value,
    onValueChange,
    min,
    max,
    readOnly,
    name,
    onBlur,
  },
  ref,
) {
  const ids = useFieldIds(idProp);
  return (
    <FieldShell
      ref={ref}
      ids={ids}
      label={label}
      hideLabel={hideLabel}
      helperText={helperText}
      error={error}
      required={required}
      hideRequiredMark={hideRequiredMark}
      disabled={disabled}
      size={size}
      fullWidth={fullWidth}
      className={className}
      sx={sx}
    >
      <OutlinedInput
        id={ids.id}
        name={name}
        type="time"
        value={value}
        error={error}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        onChange={(event) => onValueChange(event.target.value)}
        onBlur={onBlur}
        inputProps={{
          min,
          max,
          'aria-describedby': describedBy(ids, helperText, describedById),
          'aria-invalid': error === true ? true : undefined,
        }}
        notched={false}
        sx={controlTextSx(size)}
      />
    </FieldShell>
  );
});
